import { ApiClient } from '../client/ApiClient';
import { ApiResponse } from '../types';
import { KlaviyoResponse } from './types';

export class KlaviyoClient extends ApiClient {
  private readonly _klaviyoSubscribeUrl: string;
  private readonly _klaviyoEnvironment: string;

  constructor({
    klaviyoEnvironment,
    klaviyoSubscribeUrl,
  }: {
    klaviyoSubscribeUrl: string;
    klaviyoEnvironment: string;
  }) {
    super();
    this._klaviyoEnvironment = klaviyoEnvironment;
    this._klaviyoSubscribeUrl = klaviyoSubscribeUrl;
  }

  protected get requestHeaders(): Record<string, string> {
    return {
      'Content-Type': 'application/json',
      revision: '2024-10-15',
    };
  }

  subscribe = async ({ email, listId }: { email: string; listId: string }): Promise<ApiResponse<KlaviyoResponse>> => {
    const { data, statusCode, error } = await this._fetch<KlaviyoResponse>({
      path: `${this._klaviyoSubscribeUrl}?company_id=${this._klaviyoEnvironment}`,
      method: 'POST',
      body: {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email,
                },
              },
            },
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: listId,
              },
            },
          },
        },
      },
    });

    if (error) {
      console.log('error from KlaviyoClient', { error, statusCode });
      return { error, statusCode };
    }

    return { data, statusCode };
  };
}
